import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
import { certifications } from '../constants';

const Certifications = () => {
    return (
        <section id="certifications" className="section bg-white/[0.02]">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-4">Certifications</h2>
                </motion.div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {certifications.map((cert, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.1, duration: 0.5 }}
                            className="glass-panel p-6 border border-white/5 hover:border-primary-purple/30 flex items-start gap-4 group"
                        >
                            <div className="mt-1 p-2 rounded-lg bg-primary-purple/10 text-primary-purple group-hover:bg-primary-purple group-hover:text-white transition-colors">
                                <Award size={20} />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-white mb-2 leading-snug group-hover:text-primary-purple transition-colors">
                                    {cert.name}
                                </h3>
                                <p className="text-sm text-gray-500">
                                    {cert.issuer}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Certifications;
